var _style, _path, _path2, _polygon, _polygon2, _circle, _path3, _path4, _polygon3, _polygon4, _circle2, _ellipse, _path5, _polygon5, _g, _line, _polygon6, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _line2, _rect, _polygon7, _polygon8, _line3, _polyline, _rect2, _circle3, _rect3, _circle4, _rect4, _circle5, _rect5, _circle6, _rect6, _circle7, _rect7, _circle8, _ellipse2, _rect8, _ellipse3, _rect9, _ellipse4, _rect10, _ellipse5, _rect11, _ellipse6, _rect12, _ellipse7, _rect13, _line4, _path24, _path25, _path26, _path27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullsleeve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st342{fill:#FFFFFF;}\n\t.st341{fill:none;stroke:#282716;stroke-width:2;stroke-miterlimit:10;}\n\t.st340{fill:#FFFFFF;stroke:#282716;stroke-width:1.97;stroke-miterlimit:10;}\n\t.st339{fill:#FFFFFF;stroke:#282716;stroke-width:0.5;stroke-miterlimit:10;stroke-dasharray:1.26;}\n\t.st338{stroke:#282716;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st337{fill:#FFFFFF;stroke:#282716;stroke-width:2.18;stroke-miterlimit:10;}\n\t.st336{fill:#FFFFFF;stroke:#282716;stroke-width:2;stroke-miterlimit:10;}\n\t.st335{fill:#FFFFFF;stroke:#282716;stroke-width:0.32;stroke-miterlimit:10;stroke-dasharray:1.26;}\n\t.st334{fill:none;stroke:#282716;stroke-width:1.26;stroke-miterlimit:10;}\n\t.st333{fill:none;stroke:#282716;stroke-width:0.32;stroke-miterlimit:10;stroke-dasharray:1.26,1.26;}\n\t.st332{fill:none;stroke:#282716;stroke-width:0.95;stroke-miterlimit:10;}\n\t.st331{fill:none;stroke:#282716;stroke-width:0.32;stroke-miterlimit:10;stroke-dasharray:1.26;}\n\t.st330{fill:#FFFFFF;stroke:#282716;stroke-width:0.95;stroke-miterlimit:10;}\n\t.st329{fill:#010101;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st342",
    d: "M325.8,360.1l0.6,1.7c-0.2-0.1-0.3-0.2-0.4-0.4c-0.3-0.7-2.9-6.2-5.7-12.3s-7.5-16.2-10.3-22.5l-7-15.8 c-2.8-6.3-7.5-16.7-10.3-23l-1.8-4.1c-3.3-7.7-5.8-15.7-7.6-23.9l-0.3-1.6c-1.4-8.2-1.6-16.6-0.8-24.9l1.9-14.6 c1.2-8.3,2.8-16.5,4.9-24.7l1.3-4.7c2.3-8.1,5.1-16,8.5-23.6l2-4.4c2.8-6.3,7.3-6.2,10,0.2l3.6,8.8c3.1,7.8,5.7,15.8,7.8,23.9 l6.8,27c1.7,6.7,4.6,17.7,6.5,24.4l7.7,27.2c1.9,6.7,5.1,17.6,7.1,24.2l3.3,10.8c2.3,8,4.2,16.2,5.6,24.4c1,6.8,2,12.5,2,12.6 s0.1,1.1,0.3,2.3L325.8,360.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st341",
    d: "M325.8,360.1l0.6,1.7c-0.2-0.1-0.3-0.2-0.4-0.4c-0.3-0.7-2.9-6.2-5.7-12.3s-7.5-16.2-10.3-22.5l-7-15.8 c-2.8-6.3-7.5-16.7-10.3-23l-1.8-4.1c-3.3-7.7-5.8-15.7-7.6-23.9l-0.3-1.6c-1.4-8.2-1.6-16.6-0.8-24.9l1.9-14.6 c1.2-8.3,2.8-16.5,4.9-24.7l1.3-4.7c2.3-8.1,5.1-16,8.5-23.6l2-4.4c2.8-6.3,7.3-6.2,10,0.2l3.6,8.8c3.1,7.8,5.7,15.8,7.8,23.9 l6.8,27c1.7,6.7,4.6,17.7,6.5,24.4l7.7,27.2c1.9,6.7,5.1,17.6,7.1,24.2l3.3,10.8c2.3,8,4.2,16.2,5.6,24.4c1,6.8,2,12.5,2,12.6 s0.1,1.1,0.3,2.3L325.8,360.1z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st340",
    points: "368.6,370.9 333.4,383 326.3,361.8 325.8,360.1 361.3,346.9 361.5,346.8 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st339",
    points: "328.3,361.3 360.2,349.4 366.1,369.6 334.6,380.5 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st338",
    cx: 335.6,
    cy: 369.7,
    r: 3.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st342",
    d: "M97.2,361l-0.6,1.7c0.2-0.1,0.3-0.2,0.4-0.4c0.3-0.7,2.9-6.2,5.7-12.3s7.4-16.2,10.3-22.5l7-15.8 c2.8-6.3,7.5-16.7,10.3-23l1.8-4.1c3.3-7.7,5.8-15.7,7.6-23.9l0.3-1.6c1.4-8.2,1.6-16.6,0.8-24.9l-1.9-14.6 c-1.2-8.3-2.8-16.5-4.9-24.7l-1.3-4.7c-2.3-8.1-5.1-16-8.5-23.6l-2-4.4c-2.8-6.3-7.3-6.2-9.9,0.2l-3.6,8.8 c-3.1,7.8-5.7,15.8-7.9,23.9l-6.8,27c-1.7,6.7-4.6,17.7-6.5,24.4l-7.7,27.2c-1.9,6.7-5.1,17.6-7.1,24.2l-3.2,10.8 c-2.3,8-4.2,16.2-5.6,24.4c-1,6.8-1.9,12.5-2,12.6s-0.1,1.1-0.3,2.3L97.2,361z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st341",
    d: "M97.2,361l-0.6,1.7c0.2-0.1,0.3-0.2,0.4-0.4c0.3-0.7,2.9-6.2,5.7-12.3s7.4-16.2,10.3-22.5l7-15.8 c2.8-6.3,7.5-16.7,10.3-23l1.8-4.1c3.3-7.7,5.8-15.7,7.6-23.9l0.3-1.6c1.4-8.2,1.6-16.6,0.8-24.9l-1.9-14.6 c-1.2-8.3-2.8-16.5-4.9-24.7l-1.3-4.7c-2.3-8.1-5.1-16-8.5-23.6l-2-4.4c-2.8-6.3-7.3-6.2-9.9,0.2l-3.6,8.8 c-3.1,7.8-5.7,15.8-7.9,23.9l-6.8,27c-1.7,6.7-4.6,17.7-6.5,24.4l-7.7,27.2c-1.9,6.7-5.1,17.6-7.1,24.2l-3.2,10.8 c-2.3,8-4.2,16.2-5.6,24.4c-1,6.8-1.9,12.5-2,12.6s-0.1,1.1-0.3,2.3L97.2,361z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st340",
    points: "54.4,371.8 89.6,383.9 96.6,362.7 97.2,361 61.7,347.7 61.5,347.7 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st339",
    points: "94.7,362.2 62.8,350.3 56.9,370.5 88.4,381.3 "
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st338",
    cx: 87.4,
    cy: 370.5,
    r: 3.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st337",
    cx: 211.3,
    cy: 378.5,
    rx: 84.8,
    ry: 32.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st336",
    d: "M219.4,156.8l-0.8,34.6v214.1l-13.8-0.1l-16.2-0.8l-20.4-3.9l-21.4-7.1l-20.2-14.1l3-114.1l0.8-59.7l-5.3-23.4 l-8.4-20.2l0,0l0,0l-0.3-0.8l-1.4-3.4l8.2-8.1l26.5-14.7c0,0,13-5.4,20.7-8.5c0.3-0.1,0.5-0.2,0.8-0.3c2.6-1.1,4.4-1.8,4.6-1.8 l4.9,2.9l0.9,0.5l21.8,12.9l2,1.2l4.7,2.8l0.3,0.2l1.2,0.7l1.1,0.7l2.2,1.3l4,2.3l0.6,4.8l0.1,0.9L219.4,156.8z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st335",
    points: "119.2,163 181.8,128.6 182.6,130.1 120.1,164.5 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PALLA"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st342",
    d: "M244.6,126.5c2.1-1.1,4.5-1.3,6.8-0.5l19.1,7.7c1.9,0.8,5,2.3,6.8,3.3l19.9,11c2.2,1.3,4.2,2.8,6,4.5l2.8,2.8 c1.5,1.6,2,4,1.2,6.1l-7.3,17.4c-0.9,2.3-1.7,4.7-2.3,7.2l-3.6,16c-0.5,2.5-0.8,5-0.8,7.5l0.7,52.1c0,2.1,0.1,5.5,0.1,7.6 l2.8,106.5c-0.1,2.3-1.2,4.5-3,6l-14,9.8c-2.1,1.4-4.3,2.5-6.7,3.4l-14.2,4.7c-2.4,0.8-4.8,1.4-7.3,1.9l-13,2.5 c-2.5,0.4-5,0.7-7.5,0.9l-22.5,1c-2,0.1-3.7-1.4-3.8-3.4c0-0.1,0-0.1,0-0.2v-207c0-2.1,0-5.5-0.1-7.6l-0.6-27 c0-2.4,0.1-4.8,0.3-7.1c0.4-2.2,1.8-4.1,3.6-5.3L244.6,126.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st341",
    d: "M244.6,126.5c2.1-1.1,4.5-1.3,6.8-0.5l19.1,7.7c1.9,0.8,5,2.3,6.8,3.3l19.9,11c2.2,1.3,4.2,2.8,6,4.5l2.8,2.8 c1.5,1.6,2,4,1.2,6.1l-7.3,17.4c-0.9,2.3-1.7,4.7-2.3,7.2l-3.6,16c-0.5,2.5-0.8,5-0.8,7.5l0.7,52.1c0,2.1,0.1,5.5,0.1,7.6 l2.8,106.5c-0.1,2.3-1.2,4.5-3,6l-14,9.8c-2.1,1.4-4.3,2.5-6.7,3.4l-14.2,4.7c-2.4,0.8-4.8,1.4-7.3,1.9l-13,2.5 c-2.5,0.4-5,0.7-7.5,0.9l-22.5,1c-2,0.1-3.7-1.4-3.8-3.4c0-0.1,0-0.1,0-0.2v-207c0-2.1,0-5.5-0.1-7.6l-0.6-27 c0-2.4,0.1-4.8,0.3-7.1c0.4-2.2,1.8-4.1,3.6-5.3L244.6,126.5z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st334",
    x1: 243.8,
    y1: 130.2,
    x2: 307.2,
    y2: 167
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st335",
    points: "239,131.5 239.8,129.8 303.7,165.8 302.9,167.5 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st342",
    d: "M236.2,108.7c0.9,0,1.6,0.7,1.6,1.6v10.5c0,0.9-0.7,1.6-1.6,1.6h-51.7c-0.9,0-1.6-0.7-1.6-1.6v-10.5 c0-0.9,0.7-1.6,1.6-1.6H236.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st334",
    d: "M236.2,108.7c0.9,0,1.6,0.7,1.6,1.6v10.5c0,0.9-0.7,1.6-1.6,1.6h-51.7c-0.9,0-1.6-0.7-1.6-1.6v-10.5 c0-0.9,0.7-1.6,1.6-1.6H236.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st342",
    d: "M185.4,121.6c-0.9,0-1.6-0.7-1.6-1.6v-8.8c0-0.9,0.7-1.6,1.6-1.6h49.9c0.9,0,1.6,0.7,1.6,1.6v8.8 c0,0.9-0.7,1.6-1.6,1.6H185.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st333",
    d: "M185.4,121.6c-0.9,0-1.6-0.7-1.6-1.6v-8.8c0-0.9,0.7-1.6,1.6-1.6h49.9c0.9,0,1.6,0.7,1.6,1.6v8.8 c0,0.9-0.7,1.6-1.6,1.6H185.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st342",
    d: "M216.5,150.5c0.3,1,0.5,2.1,0.5,3.1v0.6c0,0.9-0.7,1.6-1.6,1.6h-4.4c-0.9,0-2.3-0.1-3.2-0.2l-1.9-0.2l-1.7-0.2 c-0.1,0-0.3-0.1-0.5-0.1l-2-0.3l-3.8-0.6c-0.9-0.2-1.8-0.5-2.6-1l-1.3-1l-0.4-0.3c0,0-0.3-0.4-0.6-0.8s0-1.2,0.7-1.8l7.8-7.1 c0.7-0.6,1.7-0.7,2.5-0.2l0,0l1.5,1c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0,1.2,0.2,2.1,0.3h0.2c0.9,0.1,1.7,0.3,1.9,0.3 c0.2,0,0.5,0.1,0.7,0.1c0.3,0.1,0.5,0.2,0.7,0.3l0.7,0.6l1.3,1l1.3,1c0.4,0.5,0.7,1.2,0.9,1.8L216.5,150.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st332",
    d: "M216.5,150.5c0.3,1,0.5,2.1,0.5,3.1v0.6c0,0.9-0.7,1.6-1.6,1.6h-4.4c-0.9,0-2.3-0.1-3.2-0.2l-1.9-0.2l-1.7-0.2 c-0.1,0-0.3-0.1-0.5-0.1l-2-0.3l-3.8-0.6c-0.9-0.2-1.8-0.5-2.6-1l-1.3-1l-0.4-0.3c0,0-0.3-0.4-0.6-0.8s0-1.2,0.7-1.8l7.8-7.1 c0.7-0.6,1.7-0.7,2.5-0.2l0,0l1.5,1c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0,1.2,0.2,2.1,0.3h0.2c0.9,0.1,1.7,0.3,1.9,0.3 c0.2,0,0.5,0.1,0.7,0.1c0.3,0.1,0.5,0.2,0.7,0.3l0.7,0.6l1.3,1l1.3,1c0.4,0.5,0.7,1.2,0.9,1.8L216.5,150.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st342",
    d: "M211,155c-1.1,0-2.1-0.1-3.2-0.2l-2.8-0.3c-0.9-0.1-2.3-0.3-3.2-0.4l-3.5-0.5c-1-0.2-2-0.6-2.9-1.2l0,0 c-0.5-0.4-1.1-0.8-1.5-1.2c-0.1-0.2,0.3-0.8,0.9-1.4l6.7-6.1c0.7-0.6,1.7-0.7,2.5-0.2c0.9,0.5,1.8,0.9,2.9,1.1l2.6,0.4 c1,0.2,2,0.6,2.9,1.3l1.1,0.9c0.8,0.7,1.4,1.5,1.8,2.5l0.4,1.2c0.3,0.9,0.5,1.9,0.5,2.9c-0.1,0.8-0.8,1.5-1.6,1.4L211,155L211,155z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st333",
    d: "M211,155c-3.1-0.1-6.1-0.4-9.1-0.9c-1.9-0.3-4.9-0.5-6.4-1.8c-0.5-0.4-1-0.8-1.5-1.3c-0.1-0.2,0.3-0.8,1-1.4 l6.7-6.1c0.7-0.6,1.7-0.7,2.5-0.2c1.4,1,3.8,1.3,5.4,1.5c1.5,0.3,2.8,1.1,4,2.1c1.1,1,1.9,2.3,2.2,3.7c0.3,1,0.5,1.9,0.5,2.9 c-0.1,0.8-0.8,1.5-1.6,1.4L211,155L211,155z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st342",
    d: "M227.4,149.5c0.6,0.6,0.9,1.4,0.6,1.8c-0.3,0.4-0.6,0.7-0.6,0.7l-0.4,0.3l-1.4,1c-0.8,0.5-1.7,0.8-2.6,1 l-2.2,0.3l-2.4,0.4l-1.2,0.2l-2,0.2l-2.1,0.2c-0.9,0.1-2.3,0.2-3.2,0.2h-4.4c-0.9,0-1.6-0.7-1.6-1.6v-0.6c0-1.1,0.2-2.1,0.5-3.1 l0.5-1.6c0.4-1,1-1.8,1.8-2.5l0.8-0.7l1.6-1.2c0.2-0.1,0.4-0.2,0.6-0.3l0.4-0.1c0.1,0,0.9-0.1,1.8-0.3l0.9-0.2l2-0.3 c0.2,0,0.4-0.1,0.6-0.2c0.1,0,0.7-0.5,1.5-1c0.7-0.5,1.4-0.8,1.6-0.7s0.8,0.7,1.4,1.3L227.4,149.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st332",
    d: "M227.4,149.5c0.6,0.6,0.9,1.4,0.6,1.8c-0.3,0.4-0.6,0.7-0.6,0.7l-0.4,0.3l-1.4,1c-0.8,0.5-1.7,0.8-2.6,1 l-2.2,0.3l-2.4,0.4l-1.2,0.2l-2,0.2l-2.1,0.2c-0.9,0.1-2.3,0.2-3.2,0.2h-4.4c-0.9,0-1.6-0.7-1.6-1.6v-0.6c0-1.1,0.2-2.1,0.5-3.1 l0.5-1.6c0.4-1,1-1.8,1.8-2.5l0.8-0.7l1.6-1.2c0.2-0.1,0.4-0.2,0.6-0.3l0.4-0.1c0.1,0,0.9-0.1,1.8-0.3l0.9-0.2l2-0.3 c0.2,0,0.4-0.1,0.6-0.2c0.1,0,0.7-0.5,1.5-1c0.7-0.5,1.4-0.8,1.6-0.7s0.8,0.7,1.4,1.3L227.4,149.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st342",
    d: "M206.6,155c-0.8,0.1-1.6-0.6-1.6-1.4c0-1,0.2-2,0.5-2.9l0.4-1.2c0.4-1,1-1.8,1.8-2.5l1.1-0.9 c0.9-0.6,1.8-1,2.9-1.3l2.6-0.4c1-0.2,2-0.6,2.8-1.1c0.8-0.5,1.8-0.4,2.5,0.2l6.7,6.1c0.6,0.6,1.1,1.2,0.9,1.4 c-0.5,0.5-1,0.9-1.5,1.3l0,0c-0.9,0.6-1.8,1-2.9,1.2l-3.6,0.6c-0.9,0.1-2.3,0.3-3.2,0.4l-2.7,0.3c-0.9,0.1-2.3,0.2-3.2,0.2 L206.6,155L206.6,155z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st333",
    d: "M206.6,155c-0.8,0.1-1.6-0.6-1.6-1.4c0.1-1.4,0.4-2.8,0.9-4.1c0.6-1.4,1.6-2.6,2.9-3.4c0.9-0.6,1.8-1,2.9-1.3 l2.6-0.4c1-0.2,2-0.6,2.8-1.1c0.8-0.5,1.8-0.4,2.5,0.2l6.7,6.1c0.6,0.6,1.1,1.2,0.9,1.4c-0.5,0.5-1,0.9-1.6,1.3 c-0.9,0.6-1.8,1-2.9,1.2l-3.6,0.6c-1.7,0.3-4.2,0.5-5.9,0.7S208.5,155,206.6,155L206.6,155z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st342",
    d: "M250.4,123.6c0.5,0.7,0.9,1.5,0.8,1.7s-0.5,1.1-1,1.9l-0.9,1.8l-0.9,1.8l-0.4,0.8c-0.1,0.2-0.5,1-0.9,1.8 l-0.2,0.4c-0.4,0.8-1,2.1-1.4,2.9l-5,10.5c-0.4,0.8-1.1,2.1-1.5,2.8l-5,8.5c-0.3,0.5-0.9,0.8-1.5,0.5c-0.2-0.1-0.3-0.2-0.4-0.3 l-4.3-4.9l-1.4-1.5l-1.4-1.6l-0.2-0.2c-0.7-0.8-1.5-1.5-2.4-2.1l-5.4-3.4c-0.7-0.5-1.5-0.9-1.6-1l-0.6-0.4l-0.4-0.3 c0.2-0.5,0.5-0.9,0.9-1.4l13.6-18.2c0.5-0.7,1.1-1.4,1.2-1.6s0.2-0.4,0.3-0.4l0.9-1.5l4.7-8.1c0.4-0.8,1-1.7,1.3-2.2 c0.3-0.4,0.5-0.9,0.6-1c0.1-0.1,0.7,0.3,1.3,0.9l2,2c0.6,0.6,1.6,1.7,2.1,2.4L250.4,123.6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st334",
    d: "M250.4,123.6c0.5,0.7,0.9,1.5,0.8,1.7s-0.5,1.1-1,1.9l-0.9,1.8l-0.9,1.8l-0.4,0.8c-0.1,0.2-0.5,1-0.9,1.8 l-0.2,0.4c-0.4,0.8-1,2.1-1.4,2.9l-5,10.5c-0.4,0.8-1.1,2.1-1.5,2.8l-5,8.5c-0.3,0.5-0.9,0.8-1.5,0.5c-0.2-0.1-0.3-0.2-0.4-0.3 l-4.3-4.9l-1.4-1.5l-1.4-1.6l-0.2-0.2c-0.7-0.8-1.5-1.5-2.4-2.1l-5.4-3.4c-0.7-0.5-1.5-0.9-1.6-1l-0.6-0.4l-0.4-0.3 c0.2-0.5,0.5-0.9,0.9-1.4l13.6-18.2c0.5-0.7,1.1-1.4,1.2-1.6s0.2-0.4,0.3-0.4l0.9-1.5l4.7-8.1c0.4-0.8,1-1.7,1.3-2.2 c0.3-0.4,0.5-0.9,0.6-1c0.1-0.1,0.7,0.3,1.3,0.9l2,2c0.6,0.6,1.6,1.7,2.1,2.4L250.4,123.6z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st342",
    d: "M225.5,149.8c-0.7-0.8-1.5-1.5-2.4-2.1l-6-3.8c-0.7-0.4-0.9-1.3-0.5-2c0,0,0.1-0.1,0.1-0.1l13.5-18.1 c0.5-0.7,1.3-1.9,1.8-2.7l5.5-9.4c0.3-0.6,1-0.8,1.6-0.5c0.1,0.1,0.3,0.2,0.4,0.3l1.1,1.2c0.6,0.6,1.6,1.7,2.1,2.4l6.8,8.8 c0.5,0.8,0.6,1.8,0.3,2.7l-3.6,7c-0.4,0.8-1,2.1-1.4,2.9l-5,10.5c-0.4,0.8-1.1,2.1-1.5,2.8l-4.4,7.4c-0.3,0.5-0.9,0.8-1.5,0.5 c-0.2-0.1-0.3-0.2-0.4-0.4L225.5,149.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st333",
    d: "M225.5,149.8c-1.4-1.8-6.6-4.6-8.4-5.9c-0.7-0.4-0.9-1.3-0.5-2c0,0,0.1-0.1,0.1-0.1 c1.2-1.7,14.8-19.5,15.3-20.8l5.5-9.4c0.3-0.6,1-0.8,1.6-0.5c0.1,0.1,0.3,0.2,0.4,0.3l1.1,1.2c0.6,0.6,1.6,1.7,2.1,2.4l6.8,8.8 c0.5,0.8,0.6,1.8,0.2,2.7c-2.9,5.5-7.4,14.7-10,20.4c-0.9,2.1-4.7,8.2-5.9,10.2c-0.3,0.5-0.9,0.8-1.5,0.5c-0.2-0.1-0.3-0.2-0.4-0.4 L225.5,149.8L225.5,149.8z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st342",
    d: "M215.4,142c-0.4,0.4-0.6,0.9-0.9,1.4c-0.5,0.2-1,0.3-1.5,0.3l-0.9,0.2c-0.6,0.1-1.3,0.2-1.9,0.2 c-0.6-0.2-1.1-0.5-1.7-0.9l-2-1.2c-0.9-0.6-1.7-1.3-2.3-2.1l-12.1-16.2c-0.5-0.7-0.2-1.3,0.6-1.3h35.6c0.9,0,1.2,0.6,0.6,1.3 L215.4,142z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st332",
    d: "M215.4,142c-0.4,0.4-0.6,0.9-0.9,1.4c-0.5,0.2-1,0.3-1.5,0.3l-0.9,0.2c-0.6,0.1-1.3,0.2-1.9,0.2 c-0.6-0.2-1.1-0.5-1.7-0.9l-2-1.2c-0.9-0.6-1.7-1.3-2.3-2.1l-12.1-16.2c-0.5-0.7-0.2-1.3,0.6-1.3h35.6c0.9,0,1.2,0.6,0.6,1.3 L215.4,142z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st332",
    x1: 214.4,
    y1: 155.6,
    x2: 217,
    y2: 405.4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 157.4,
    className: "st331",
    width: 6.8,
    height: 248.6
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st330",
    points: "227.9,200.7 274.9,200.7 274.9,239.1 255.1,247.8 230.5,240.7 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st335",
    points: "231.3,240 228.9,201.6 274,201.6 274,238.5 255.1,246.9 "
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st331",
    x1: 228.6,
    y1: 209.1,
    x2: 274.9,
    y2: 208
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st331",
    points: "126.6,375.5 147.4,389.9 162.3,395.4 173.5,398.5 185,400.4 197.3,401.8 204.1,401.8 204.9,403.3  212.4,403.3 216.9,402.7 225.6,402.7 239.9,400.8 254.8,397.7 268.8,393.3 279.1,388.3 288.8,382.1 296.9,376.4 "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 209.3,
    y: 149.8,
    transform: "matrix(0.993 -0.1182 0.1182 0.993 -16.265 26.0617)",
    className: "st342",
    width: 4.4,
    height: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st342",
    cx: 210.8,
    cy: 150.2,
    r: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 210.3,
    y: 169.1,
    className: "st342",
    width: 0.6,
    height: 4.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st342",
    cx: 210.6,
    cy: 172,
    r: 2.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 210.3,
    y: 359.5,
    className: "st342",
    width: 0.6,
    height: 4.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st342",
    cx: 210.6,
    cy: 362.4,
    r: 2.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 310.3,
    className: "st342",
    width: 0.6,
    height: 4.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st342",
    cx: 210.8,
    cy: 313.2,
    r: 2.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 210.2,
    y: 258.4,
    className: "st342",
    width: 0.6,
    height: 4.4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st342",
    cx: 210.5,
    cy: 261.4,
    r: 2.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 210.2,
    y: 212.5,
    className: "st342",
    width: 0.6,
    height: 4.4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st342",
    cx: 210.5,
    cy: 215.4,
    r: 2.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9384 -0.3456 0.3456 0.9384 -39.1625 82.0741)",
    className: "st329",
    cx: 210.6,
    cy: 150.9,
    rx: 2.2,
    ry: 2.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 208.1,
    y: 150.6,
    transform: "matrix(0.9384 -0.3456 0.3456 0.9384 -39.1292 82.1457)",
    className: "st329",
    width: 5.4,
    height: 0.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st329",
    cx: 210.6,
    cy: 177.6,
    rx: 2.3,
    ry: 2.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 210.4,
    y: 174.6,
    className: "st329",
    width: 0.5,
    height: 5.4
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st329",
    cx: 210.3,
    cy: 218.4,
    rx: 2.3,
    ry: 2.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 210.1,
    y: 215.4,
    className: "st329",
    width: 0.5,
    height: 5.4
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st329",
    cx: 210.3,
    cy: 263,
    rx: 2.3,
    ry: 2.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 210.1,
    y: 260.1,
    className: "st329",
    width: 0.5,
    height: 5.4
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st329",
    cx: 210.8,
    cy: 303.8,
    rx: 2.3,
    ry: 2.2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 300.9,
    className: "st329",
    width: 0.5,
    height: 5.4
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st329",
    cx: 210.8,
    cy: 342.6,
    rx: 2.3,
    ry: 2.2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 339.6,
    className: "st329",
    width: 0.5,
    height: 5.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st334",
    x1: 181.7,
    y1: 127.7,
    x2: 117.8,
    y2: 163.8
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st342",
    d: "M206,142.3c0.3,0.3,0.5,0.7,0.6,1.1l-0.7,0.4L204,145l-5.3,3.4c-0.9,0.6-1.7,1.3-2.4,2.1l-0.2,0.3 c-0.6,0.7-1.2,1.4-1.4,1.5l-1.3,1.6l-4.2,4.8c-0.4,0.5-1,0.6-1.5,0.2c-0.1-0.1-0.3-0.2-0.3-0.4l-5-8.5c-0.5-0.8-1.1-2-1.5-2.8 l-5-10.4c-0.4-0.8-1-2.1-1.4-2.9v-0.1c-0.4-0.8-0.8-1.6-0.9-1.8c-0.1-0.2-0.3-0.6-0.4-0.8c-0.1-0.2-0.5-1-0.9-1.8l-1-2 c-0.4-0.8-0.8-1.6-1-1.9c-0.2-0.3,0.2-1,0.7-1.7l7.2-9.2c0.7-0.8,1.4-1.7,2.1-2.4l1.7-1.9l1.2-1.3c0,0,0.2,0.2,0.4,0.5 s0.7,1.2,1.1,2l5.2,8.9c0.4,0.8,0.9,1.5,0.9,1.5l0.3,0.4l1.2,1.6l12.1,16.2C204.8,140.7,205.6,141.7,206,142.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st334",
    d: "M206,142.3c0.3,0.3,0.5,0.7,0.6,1.1l-0.7,0.4L204,145l-5.3,3.4c-0.9,0.6-1.7,1.3-2.4,2.1l-0.2,0.3 c-0.6,0.7-1.2,1.4-1.4,1.5l-1.3,1.6l-4.2,4.8c-0.4,0.5-1,0.6-1.5,0.2c-0.1-0.1-0.3-0.2-0.3-0.4l-5-8.5c-0.5-0.8-1.1-2-1.5-2.8 l-5-10.4c-0.4-0.8-1-2.1-1.4-2.9v-0.1c-0.4-0.8-0.8-1.6-0.9-1.8c-0.1-0.2-0.3-0.6-0.4-0.8c-0.1-0.2-0.5-1-0.9-1.8l-1-2 c-0.4-0.8-0.8-1.6-1-1.9c-0.2-0.3,0.2-1,0.7-1.7l7.2-9.2c0.7-0.8,1.4-1.7,2.1-2.4l1.7-1.9l1.2-1.3c0,0,0.2,0.2,0.4,0.5 s0.7,1.2,1.1,2l5.2,8.9c0.4,0.8,0.9,1.5,0.9,1.5l0.3,0.4l1.2,1.6l12.1,16.2C204.8,140.7,205.6,141.7,206,142.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st342",
    d: "M183,149.5c-0.5-0.8-1.1-2-1.5-2.8l-5-10.4c-0.4-0.8-1-2.1-1.4-2.9l-3.5-7c-0.4-0.9-0.3-1.9,0.2-2.7l6.8-8.8 c0.5-0.7,1.5-1.8,2.1-2.4l1.1-1.2c0.4-0.5,1.1-0.5,1.6-0.1c0.1,0.1,0.2,0.2,0.3,0.4l5.5,9.4c0.4,0.8,1.2,2,1.8,2.7l13.5,18.1 c0.5,0.6,0.4,1.6-0.3,2c0,0-0.1,0.1-0.1,0.1l-6,3.8c-0.9,0.6-1.7,1.3-2.4,2.1l-6.4,7.4c-0.4,0.5-1,0.6-1.5,0.2 c-0.1-0.1-0.3-0.3-0.3-0.4L183,149.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st333",
    d: "M183,149.5c-1.1-1.8-5.4-11.1-6.5-13.2s-3.9-7.9-5-10c-0.4-0.9-0.3-1.9,0.2-2.7c2.1-2.7,7.6-10.1,10-12.3 c0.4-0.5,1.1-0.6,1.6-0.1c0.1,0.1,0.2,0.2,0.3,0.4c1.3,2.1,5.8,10.3,7.3,12.1l13.6,18.1c0.5,0.6,0.4,1.6-0.3,2.1 c0,0-0.1,0.1-0.1,0.1l-6,3.8c-2,1.1-7.2,7.7-8.8,9.4c-0.4,0.5-1,0.6-1.5,0.2c-0.1-0.1-0.3-0.2-0.3-0.4L183,149.5L183,149.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullsleeve);
export default __webpack_public_path__ + "static/media/FULL SLEEVE.dcde6e53ab548fc2599e0acd695bae62.svg";
export { ForwardRef as ReactComponent };